import service from "@/utils/requestBackend";

export function getGoodPriceFeedBackApi(data) {
    return service({
        url: "/xitunbao/goodsPriceFeedBack/list",
        method: "post",
        data
    });
}